import { createContext } from 'react'

export interface OTLContextProps {
  isArticle?: boolean
  isMinimal?: boolean
  isPreview?: boolean
}

export const OTLContext = createContext<OTLContextProps | undefined>({
  isArticle: false,
  isMinimal: false,
  isPreview: false
})
